// extracted by mini-css-extract-plugin
export var cta = "styles-module--cta--998c8";
export var desktop = "1340px";
export var desktopMedia = "styles-module--desktopMedia--1d526";
export var flexContainer = "styles-module--flexContainer--72f8f";
export var giant = "2200px";
export var header = "styles-module--header--e337c";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var leftColumn = "styles-module--leftColumn--eacd9";
export var mediaOnRight = "styles-module--mediaOnRight--d180e";
export var mobile = "400px";
export var mobileMedia = "styles-module--mobileMedia--a737e";
export var pollContainer = "styles-module--pollContainer--1e0b0";
export var pollItem = "styles-module--pollItem--5abdb";
export var productLink = "styles-module--productLink--54163";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";
export var textBlockHeader = "styles-module--textBlockHeader--0c925";
export var textBlockText = "styles-module--textBlockText--afcb4";
export var video = "styles-module--video--3ba9b";